import { render, staticRenderFns } from "./FormB.vue?vue&type=template&id=2aa0c99b&scoped=true&"
import script from "./FormB.vue?vue&type=script&lang=js&"
export * from "./FormB.vue?vue&type=script&lang=js&"
import style0 from "./FormB.vue?vue&type=style&index=0&id=2aa0c99b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0c99b",
  null
  
)

export default component.exports